async function coachCalendarRelinkAccountsPagePreloader(): Promise<void> {
    await import("./coach.calendar.page.relink-accounts")
    await import("./coach.calendar.container.relink-accounts")
}

async function coachCalendarAccountsPagePreloader(): Promise<void> {
    await import("./coach.calendar.page.accounts")
    await import("./coach.calendar.container.accounts")
}

export { coachCalendarRelinkAccountsPagePreloader, coachCalendarAccountsPagePreloader }
